module.exports = __webpack_public_path__ + "static/img/hair_09.abdc2bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_09.png
// module id = C89/
// module chunks = 0